module.exports = __webpack_public_path__ + "img/portrait-sara-laptop.7fb6093d.jpg";